import styled from 'styled-components';
import BtnRoundSmOutlinePurple from '../BtnRoundSmOutlinePurple';

const BtnRoundSmOutlineGray = styled(BtnRoundSmOutlinePurple)`
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.5);
`;

export default BtnRoundSmOutlineGray;
